import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: {
    key: 'delete-file-dialog-title',
    defaultValue: 'Deseja excluir este arquivo?',
  },
  description: {
    key: 'delete-file-dialog-description',
    defaultValue:
      'Ao excluir este arquivo, todo o contexto gerado pela Zai será perdido e as informações contidas nele não poderão ser reutilizadas.',
  },
})
